/* global FollowButton */
import React from "react";

class Entity extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      entity: props.entity
    };
  }

  componentDidMount () {
    const hint = document.createElement("div");
    const button = document.createElement("button");
    const name = document.createElement("h3");
    const description = document.createElement("h4");

    name.innerText = this.state.entity.name;
    name.className = "popover__title";

    description.innerText = this.getDescription();
    description.className = "popover__description";

    button.setAttribute("data-follow-type", this.state.entity.category);
    button.setAttribute("data-follow-id", this.state.entity.original_id);

    // Insights follow button
    button.setAttribute("data-insights-category", "follow");
    button.setAttribute("data-insights-label", "my-ad-follow");
    button.setAttribute("data-insights-value", this.state.entity);

    button.className = "afd-btn afd-btn--full afd-btn--small popover__action";
    button.followButton = new FollowButton({ element: button, sdk: Notifications });

    hint.appendChild(name);
    hint.appendChild(description);
    hint.appendChild(button);

    Notifications.attachPopover(this.el, hint);
  }

  getDescription () {
    switch (this.state.entity.category) {
      case "company":
        return I18n.t("jslibrary.entities.company");
      case "user":
        return I18n.t("jslibrary.entities.user");
      case "office":
        return I18n.t("jslibrary.entities.office");
      case "expert":
        return I18n.t("jslibrary.entities.expert");
      case "photographer":
        return I18n.t("jslibrary.entities.photographer");
      case "author":
        return I18n.t("jslibrary.entities.author");
      case "category":
        return I18n.t("jslibrary.entities.category");
      case "product_category":
        return I18n.t("jslibrary.entities.category");
      case "tag":
        return I18n.t("jslibrary.entities.tag");
      case "landing":
        return I18n.t("jslibrary.entities.landing");
      default:
        return "";
    }
  }

  getPath () {
    const entity = this.state.entity;
    let appendSite = `/${entity.site}`;

    // For us, we don't show the site on the path
    if (entity.site === "us") {
      appendSite = "";
    }

    switch (entity.category) {
      case "company":
        return `${appendSite}/companies/${entity.original_id}/${entity.slug}`;
      case "user":
        return `${appendSite}/@${entity.slug}`;
      case "office":
        return `${appendSite}/office/${entity.slug}`;
      case "photographer":
        return `${appendSite}/photographer/${entity.slug}`;
      case "author":
        return `${appendSite}/author/${entity.slug}`;
      case "profile":
        return `${appendSite}/author/${entity.slug}`;
      case "category":
        return `/search${appendSite}/projects/categories/${entity.slug}`;
      case "product_category":
        return `/search/${appendSite}/products/categories/${entity.slug}`;
      case "landing":
        return `${appendSite}/${entity.slug}`;
      case "tag":
        return `${appendSite}/tag/${entity.slug}`;
    }
  }

  generateUrl () {
    const domains = {
      us: "archdaily.com",
      cl: "archdaily.cl",
      pe: "archdaily.pe",
      co: "archdaily.co",
      br: "archdaily.com.br",
      mx: "archdaily.mx",
      cn: "archdaily.cn"
    };
    const entity = this.state.entity;
    const site = this.state.entity.site;
    const domain = domains[site];
    const subdomain = entity.category === "user" ? "my" : "www";
    const path = this.getPath();

    return `https://${subdomain}.${domain}${path}`;
  }

  render () {
    const entity = this.state.entity;
    const { name } = entity;
    const tracking = "?ad_medium=myad_feed&ad_name=entity-link";
    const image = entity.image || "https://assets.adsttc.com/doodles/flat/logo-blue-isotype.svg";

    const styles = {
      backgroundImage: `url(${image})`
    };

    const url = entity.url ? entity.url : this.generateUrl();

    return (
      <a href={url + tracking} className="afd-entity" ref={el => (this.el = el)}>
        <span className="afd-entity__avatar" style={styles} />
        <span className="afd-entity__name">{name}</span>
      </a>
    );
  }
}

export default Entity;
